module.exports = __webpack_public_path__ + "d2a48e5adfc97bc0349fb5c2654d300b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile7.png
// module id = 1890
// module chunks = 0